import Vue from "vue";
import axios from "axios";
import deepmerge from "deepmerge";
// import queryString from 'query-string'

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";
const ofertaCamp = process.env.VUE_APP_CAMP || "ofertaDigital";
const om = {
  consultaHash(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(`${API_BASE_SRC}/ventaTC/wp/consultarOferta`, body);
  },
  simulacionMock(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(`${API_BASE_SRC}/plazoFijo/simularIndividuo`, body);
  },
  controlarCuitCbu(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(`${API_BASE_SRC}/datosCuenta/controlarCuitCbu`, body);
  },
  controlarCuitAlias(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(
      `${API_BASE_SRC}/datosCuenta/controlarCuitAlias`,
      body
    );
  },
  consultarAlias(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(`${API_BASE_SRC}/datosCuenta/consultarAlias`, body);
  },
  confirmacionPF(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(`${API_BASE_SRC}/confirmacionPF/confirmacion`, body);
  },
  consultaRenaper(hash) {
    const body = JSON.parse(JSON.stringify(hash));
    return axios.post(
      `${API_BASE_SRC}/confirmacionPF/consultaRenaper`,
      body
    );
  },
  consultaMock(path, body) {
    body = JSON.parse(JSON.stringify(body));
    return axios.post(path, body);
  },
  consulta(payload) {
    const body = JSON.parse(JSON.stringify(payload));
    body.captchaResponse = body.captcha;
    delete body.captcha;
    body.nroDoc = body.numeroDoc;
    delete body.numeroDoc;

    body.tipoTel = "0";
    body.caracteristicaTel = body.celular.area;
    body.nroTel = body.celular.numero;
    delete body.celular;
    body.c = `${ofertaCamp}${body.tcode}`;
    body.fingerprint = "9999991212";

    body.referrer = window.document.referrer;
    body.originUrl = window.location.href;

    return axios.post(`${API_BASE_SRC}/ventaTC/wp/consultarOferta`, body);
  },
  obtenerCA(cark, _callback) {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    //    axios.post(`${API_BASE_SRC}/fnet/mod/bbva/NL-CarroAbandonado.do?method=consultaDatosDeAbandono`, queryString.stringify({ CA: '{ "randomKey" : "' + cark + '"}' }), config).then(resp => {
    axios
      .post(
        `${API_BASE_SRC}/carroAbandonado/consultaDatosDeAbandono`,
        { randomKey: cark },
        config
      )
      .then((resp) => {
        _callback(resp);
      })
      .catch((error) => {
        Vue.$log.error("Error obteniendo CA: " + error);
      });
  },
  pasoCA(cark, name, payload) {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Clonar payload para evitar mutar el state por ref
    let payloadOferta = deepmerge({}, payload.oferta);
    // Borrar randomkey de la oferta y el carro (ya que se envía como randomkey acá)
    delete payloadOferta.randomkey;
    delete payloadOferta.carro;

    // Payload de consulta
    let payloadConsulta = deepmerge({}, payload.consulta);
    payloadConsulta.c = `${ofertaCamp}${payload.tcode}`;

    let pasos = {
      consulta: payloadConsulta,
      oferta: payloadOferta,
      paso1: payload.paso1,
      paso2: payload.paso2,
      paso3: payload.paso3,
      paso4: payload.paso4,
    };

    let obj = {
      randomKey: cark,
      paso: name,
      datos: JSON.stringify(pasos),
    };

    //let str = queryString.stringify()
    //axios.post(`${API_BASE_SRC}/fnet/mod/bbva/NL-CarroAbandonado.do?method=pasoACarroAbandonadoMotorTC`, str, config).then(resp => {
    axios
      .post(`${API_BASE_SRC}/carroAbandonado/persistirNuevoPaso`, obj, config)
      .then((resp) => {
        Vue.$log.info("paso guardado", resp);
      })
      .catch((error) => {
        Vue.$log.error("Error grabando CA: " + error);
      });
  },
  confirmacion(payload) {
    let body = JSON.parse(JSON.stringify(payload));

    return axios.post(`${API_BASE_SRC}/ventaTC/wp/confirmarOferta`, body);
  },
};

export default om;
